import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { message } from "ant-design-vue";
import { useTrainingStore } from "@/store/training/training";
import { useUserInfoStore } from "@/store/userInfo";
import Cookies from "universal-cookie";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: () => import("@/layouts/BasicLayout.vue"),
    children: [
      {
        path: "/",
        redirect: "/intro",
      },
      {
        path: "intro",
        name: "intro",
        component: () =>
          import(/* webpackChunkName: "intro" */ "@/views/intro/UserIntro.vue"),
      },
      {
        path: "dataset",
        name: "dataset",
        component: () =>
          import(
            /* webpackChunkName: "dataset" */ "@/views/dataset/DatasetOverview.vue"
          ),
      },
      {
        path: "model",
        name: "model",
        component: () =>
          import(/* webpackChunkName: "model" */ "@/views/model/ModelView.vue"),
        children: [
          {
            path: "/model",
            redirect: "/model/my",
          },
          {
            path: "my",
            name: "myModel",
            component: () =>
              import(
                /* webpackChunkName: "model" */ "@/views/model/MyModel.vue"
              ),
          },
          {
            path: "editor",
            name: "modelEditor",
            component: () =>
              import(
                /* webpackChunkName: "model" */ "@/views/model/ModelEditor.vue"
              ),
          },
        ],
      },
      {
        path: "training",
        name: "training",
        component: () =>
          import(
            /* webpackChunkName: "training" */ "@/views/training/ModelTraining.vue"
          ),
      },
      {
        path: "evaluation",
        name: "evaluation",
        component: () =>
          import(
            /* webpackChunkName: "training" */ "@/views/evaluation/ModelEvaluation.vue"
          ),
      },
      {
        path: "history",
        name: "history",
        component: () =>
          import(
             /* webpackChunkName: "training" */ "@/views/history/TrainingHistory.vue"
           ),
      },
      
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const cookies = new Cookies();
  const token = cookies.get("token");
  if (token) {
    const userInfoStore = useUserInfoStore();
    userInfoStore.access = token.access;
    userInfoStore.refresh = token.refresh;
    userInfoStore.userId = cookies.get("name");
    userInfoStore.loginMethod = "oidc";
    cookies.remove("name");
    cookies.remove("token");
    userInfoStore.init().then();
  }

  const trainingStore = useTrainingStore();
  if (to.name === "evaluation" && !trainingStore.trained) {
    if (from.name === null) {
      router.replace({ name: "intro" }).then();
      return;
    }
    message.warning("Train a model first to evaluate the model!").then();
  } else {
    if (to.path !== from.path) {
      NProgress.start();
    }
    next();
  }
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
